/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'slot API',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events:{
						propagationInfo: {
							info: {
								slotId: this.getId()
							},
							callStack: {
								name: 'getSlot',
								params: [this.getId()]
							}
						},
						actions: {
							'removeDataItemsMapping': {
								eventName: 'dataitems:removeMapping',
								getInfo: (args) => {
									return {
										dataItemIdList: args[0]
									};
								},
								getUndoActions: (args) => {
									const undoActions = [];
									const ids = args[0];
									if (ids){
										let lastIndex;
										ids.forEach(id => {
											const dataItem = this.getDataItem(id);
											if (dataItem){
												const currentIndex = this.getDataItemIndex(id);
												// add an addColumn reverse action
												if (currentIndex !== lastIndex + 1){
													undoActions.push({
														name: 'addDataItemsMapping',
														params: [[], currentIndex]
													});
												}
												const lastAction = undoActions[undoActions.length -1];
												// add the column id to column ids param
												lastAction.params[0].push(dataItem.getId());
												lastIndex = currentIndex;
											}
										});
									}
									return undoActions;
								}
							},
							'addDataItemsMapping': {
								eventName: 'dataitems:addMapping',
								isResolvePostResponse: true,
								getInfo: (args) => {
									return {
										dataItemIdList: args[0],
										position: args[1] || 0
									};
								},
								getUndoActions: (args) => {
									return [{
										name: 'removeDataItemsMapping',
										params:[args[0]]
									}];
								}
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}

	return APISpec;
});
